import { connect } from 'react-redux'
//import { state_update } from '../actions'
//import LeftPanel from './LeftPanel'
import MainBodyPortrait from './MainBodyPortrait';
import { state_start_over,state_update } from '../actions'
import {decodeHtml} from '../reducers/utils'
import ReactGA from 'react-ga';

const mapStateToProps = (state, ownProps) => ({
  //title2:console.log('st',state),
  title:(['9000','9082'].indexOf(state['style']) !== -1 && state.clist === '-1' && state.acat === '-1' &&( (state.m ==='-1' && state.style==='9000') ||(state.locket ==='-1' &&state.style==='9082')))?'':decodeHtml(state['title']),
  
  cfg:state['cfg1'],
  showSticky:state['showSticky'] ? false: true
  
})
  
 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onStartOver: ( () =>{
    ReactGA.event({
      category: 'StartOver',
      action:'StartOver' 
    });
    dispatch(state_start_over())}),
  onPushOpenBox: ( () =>{
    ReactGA.event({
      category: 'Zoom',
      action:'Zoom' 
    });
    dispatch(state_update({attr:'pushOpenBox',value:true}))})
  //onClick: ( () => dispatch(state_update({attr:ownProps.attr,value:ownProps.value})))
//  onClick: ( () => dispatch(state_update({attr:'review',value:false})))
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainBodyPortrait)


// WEBPACK FOOTER //
// ./src/layout/MainBodyPortraitWrap.js